import IdleTimer from "react-idle-timer";
import React, { useEffect, useMemo, useState } from "react";
import queryString from "query-string";
import { AiOutlineSearch } from "react-icons/ai";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import UserMenuIcon from "components/MI/UserMenuIcon";
import { signOut } from "utils/functions";
import { useTour } from "hooks/useTour";

import TourBalloon from "components/NewTour/TourBallon";
import api from "services/api";
import {
  Address,
  BoxAddressBreadcrumb,
  BoxNameAddress,
  BoxNotificationProfile,
  BoxTwoBars,
  Breadcrumb,
  Container,
  ContainerWrap,
  ContentSearch,
  ContentSearchWrap,
  InputSearch,
  IntroButton,
  Name,
  ResponsiveGradient,
  Separator,
  TwoBars,
} from "./styles";

type UserMenuNewProps = {
  breadcrump?: string;
  intro?: boolean;
};

const UserMenuNew = ({
  breadcrump,
  intro = false,
}: UserMenuNewProps): JSX.Element => {
  const [search, setSearch] = useState("");
  const selectedUnit = useSelector(
    // @ts-ignore
    (state) => state.selectUnitReducer.selectedUnit
  );
  const history = useHistory();
  const location = useLocation();
  const addressLine = localStorage.getItem(
    "@UltragazEmpresarial:customerAddressLine"
  );

  const { showTour, tourStep, setShowTour, tourType } = useTour();

  useEffect(() => {
    (async () => {
      const userId = localStorage.getItem("@UltragazEmpresarial:userId");
      const buttonElement = document.getElementById("intro-button");
      const userResponse = await api.get(
        `industrial/customer/v1/users/${userId}`,
        {
          headers: {
            access_token: localStorage.getItem(
              "@UltragazEmpresarial:accessToken"
            ),
          },
        }
      );

      if (userResponse.status === 200) {
        const { guideNavigationTour } = userResponse.data;

        if (guideNavigationTour === false) {
          if (buttonElement) {
            buttonElement.click();

            api.patch(
              `industrial/customer/v1/users/${userId}`,
              {
                guideNavigationTour: true,
              },
              {
                headers: {
                  access_token: localStorage.getItem(
                    "@UltragazEmpresarial:accessToken"
                  ),
                },
              }
            );
          }
        }
      }
    })();
  }, []);

  const handleOnIdle = (): void => {
    signOut();
  };

  const onEnterSearch = (): void => {
    history?.push(`/pesquisa/?search=${search}`);
  };

  const searchUrl = useMemo(() => {
    return queryString.parse(location.search)?.search;
  }, [location]);

  const address = useMemo(() => {
    if (selectedUnit?.address) {
      const unit =
        selectedUnit.address.find((unit) => unit.addressType === "SHIP_TO") ||
        {};
      return `${unit?.address || unit?.fullAddress}, ${unit?.number || "S/N"}${
        unit?.complement ? `, ${unit?.complement}` : ""
      }${unit.neighborhoods ? `, ${unit?.neighborhoods}` : ""}${
        unit?.city ? `, ${unit?.city}` : ""
      }${unit?.stateCode ? `-${unit?.stateCode}` : ""}`;
    }

    return "";
  }, [selectedUnit]);

  return (
    <ContainerWrap>
      <Container
        showTour={
          showTour &&
          tourType === "home" &&
          (tourStep === 2 || tourStep === 3 || tourStep === 4)
        }
      >
        <IdleTimer
          timeout={15 * 60 * 1000}
          onIdle={handleOnIdle}
          debounce={250}
        />
        <ResponsiveGradient>
          <BoxTwoBars>
            <TwoBars>//</TwoBars>
            <BoxNameAddress>
              <Name>{selectedUnit?.condominiumName || addressLine}</Name>
              <BoxAddressBreadcrumb>
                <Address>{address}</Address>
                <Breadcrumb style={{ display: breadcrump ? "block" : "none" }}>
                  {breadcrump ?? ""}
                </Breadcrumb>
              </BoxAddressBreadcrumb>
            </BoxNameAddress>
          </BoxTwoBars>

          <BoxNotificationProfile>
            <ContentSearchWrap>
              <ContentSearch>
                <AiOutlineSearch />
                <InputSearch
                  placeholder="Pesquisar"
                  value={search ?? searchUrl}
                  onChange={(e) => setSearch(e?.currentTarget?.value)}
                  onKeyUpCapture={(e) => e?.key === "Enter" && onEnterSearch()}
                />
              </ContentSearch>
              {showTour && tourType === "home" && tourStep === 4 && (
                <TourBalloon
                  title="Caixa de pesquisa"
                  content="Digite aqui o que gostaria de encontrar no portal e te mostramos o caminho!"
                  position={{
                    left: "20px",
                    right: "0",
                    top: "38px",
                    arrowPosition: "top",
                    maxWidth: "unset",
                    width: "200px",
                  }}
                />
              )}
            </ContentSearchWrap>
            {intro && (
              <>
                <Separator />
                <IntroButton
                  id="intro-button"
                  onClick={() => setShowTour(true)}
                >
                  <span className="mdi mdi-compass-outline" />
                  Ver tour da Página
                </IntroButton>
              </>
            )}
            <UserMenuIcon />
          </BoxNotificationProfile>
        </ResponsiveGradient>
      </Container>
      {showTour && tourType === "home" && tourStep === 2 && (
        <TourBalloon
          title="Dados da unidade"
          content="Aqui são exibidas suas Informações referentes a sua unidade."
          position={{
            left: "20px",
            right: "0",
            top: "62px",
            arrowPosition: "top",
            maxWidth: "unset",
            width: "200px",
          }}
        />
      )}
    </ContainerWrap>
  );
};

export default UserMenuNew;
